import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthFrame from "@/components/AuthFrame";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
      toast.success("Controleer je mail");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Resetmail aanvragen mislukt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFrame
      title="Wachtwoord vergeten"
      subtitle="Vul je e-mailadres in. Je ontvangt een veilige link om een nieuw wachtwoord te kiezen."
      heroTitle="Zo weer bij je kasten."
      heroText="We sturen een eenmalige link die 30 minuten geldig blijft."
      footer={<Link to="/login" className="font-semibold text-amber-700 hover:text-amber-800">Terug naar inloggen</Link>}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="reset-email" className="text-sm font-semibold text-zinc-800">E-mailadres</Label>
          <Input id="reset-email" type="email" value={email} onChange={(event) => { setEmail(event.target.value); setSent(false); }} autoComplete="email" required className="h-[52px] rounded-xl text-base" />
        </div>
        {sent && (
          <div className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-950">
            Als dit e-mailadres bij ons bekend is, ontvang je zo een resetlink.
          </div>
        )}
        <Button type="submit" disabled={loading} className="w-full h-[52px] rounded-xl text-base bg-amber-600 hover:bg-amber-700 font-bold">
          {loading ? "Bezig..." : "Stuur resetlink"}
        </Button>
      </form>
    </AuthFrame>
  );
}
